module.exports = __webpack_public_path__ + "img/minus-gray-16x16.95487b98.svg";